import React, { Fragment } from "react";
import "./Services.css";
import biometric from "./biometric.svg";
import hack from "./hack.svg";
import internet from "./internet.svg";
import hacker from "./hacker.svg";
import Fade from "react-reveal/Fade";
import { Dimensions } from '../../Helper/sitedimension';
import { Link } from "react-router-dom";

const services = () => {
  const { width } = Dimensions.useWindowDimensions();
  return (
    <Fragment>
      {width > 500 ?
        <div className="services container-fluid sec-bgimg">
          <div className="row">
            <div className="col-8 section">
              <h2>
                <Fade delay={300}>Cutting Edge</Fade>
              </h2>
              <h4>
                <Fade delay={500}>Services</Fade>
              </h4>
              <p className="content">
                <Fade delay={800}>
                  We help you find gaps in your system so that it is less prone to cyber attacks. With Secure Blink, you can analyze, predict, and report the intensity of cyber security that is needed for your website.
              </Fade>
              </p>
              <div className="row  circles">
                <Fade delay={1000}>
                  <div className="col-1.5 circle1">
                    <img src={biometric} className="biometric" alt="biometric" />
                    <p className="va">VA</p>
                  </div>
                </Fade>
                <Fade delay={1000}>
                  <div className="col-1.5 circle2">
                    <img src={internet} className="internet" alt="internet" />
                    <p className="pt">PT</p>
                  </div>
                </Fade>
                <Fade delay={1000}>
                  <div className="col-1.5 circle3">
                    <img src={hack} className="hack" alt="hack" />
                    <p className="grc">GRC</p>
                  </div>
                </Fade>
                <Fade delay={1000}>
                  <div className="col-2.5 circle4">
                    <img src={hacker} className="hacker" alt="hacker" />
                    <p className="redteaming">Red Teaming</p>
                  </div>
                </Fade>
              </div>
              <Fade delay={1200}>
                <Link to='/about'>
                  <button type="button" className="btn btn-outline-white" id="butt">
                    <span className="btn-content">Know More</span>
                  </button>
                </Link>
              </Fade>
            </div>
          </div>
        </div> :
        <Fragment>
          <div className="row servservhome" style={{ marginLeft: "0px", marginRight: "0px" }}>
            <div className="col-8">
              <Fade top delay={250}>
                <h2>Cutting Edge</h2>
              </Fade>
              <Fade top delay={250}>
                <h4>Services</h4>
              </Fade>
              <p className="content">
                <Fade delay={500}>
                  We help you find gaps in your system so that it is less prone to cyber attacks. With Secure Blink, you can analyze, predict, and report the intensity of cyber security that is needed for your website.
            </Fade>
              </p>
              <div className="row  circlesservhome">
                <div className="row">
                  <Fade delay={750}>
                    <div className="col-1.5 circle1servhome">
                      <img src={biometric} className="biometric" alt="biometric" />
                      <p className="va">VA</p>
                    </div>
                  </Fade>
                  <Fade delay={800}>
                    <div className="col-1.5 circle2servhome">
                      <img src={internet} className="internet" alt="internet" />
                      <p className="pt">PT</p>
                    </div>
                  </Fade>
                </div>
                <div className="row" style={{ marginTop: "50px" }}>
                  <Fade delay={800}>
                    <div className="col-1.5 circle3servhome">
                      <img src={hack} className="hack" alt="hack" />
                      <p className="grc">GRC</p>
                    </div>
                  </Fade>
                  <Fade delay={800}>
                    <div className="col-2.5 circle4servhome">
                      <img src={hacker} className="hacker" alt="hacker" />
                      <p className="redteaming">Red Teaming</p>
                    </div>
                  </Fade>
                </div>
              </div>
              <Fade delay={1200}>
                <Link to='/about'>
                  <button type="button" className="btn btn-outline-white" id="butt">
                    <span className="btn-content">Know More</span>
                  </button>
                </Link>
              </Fade>
            </div>
          </div>
        </Fragment>
      }
    </Fragment>
  );
};

export default services;
